//T-27 · Focus not obscured — WCAG 2.4.11 START
function trapFocusInDrawer(drawerElement) {
  if (!drawerElement) return;
  
  const focusableElements = drawerElement.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  
  if (focusableElements.length === 0) return;
  
  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];
  
  function handleKeyDown(e) {
    if (e.key !== 'Tab') return;
    
    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }
  
  drawerElement.addEventListener('keydown', handleKeyDown);
  
  drawerElement._focusTrapHandler = handleKeyDown;
}

function removeFocusTrap(drawerElement) {
  if (drawerElement && drawerElement._focusTrapHandler) {
    drawerElement.removeEventListener('keydown', drawerElement._focusTrapHandler);
    delete drawerElement._focusTrapHandler;
  }
}

const cartDrawer = document.querySelector('.cart-drawer');
if (cartDrawer) {
  cartDrawer.classList.add('open');
  trapFocusInDrawer(cartDrawer);
  const firstFocusable = cartDrawer.querySelector('button, [href], input');
  if (firstFocusable) firstFocusable.focus();
}

if (cartDrawer) {
  cartDrawer.classList.remove('open');
  removeFocusTrap(cartDrawer);
  document.querySelector('.cart-trigger')?.focus();
}
//T-27 · Focus not obscured — WCAG 2.4.11 END